import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { CreditType } from '../../types'
import ActionTypes from './actionTypes'

type FetchCreditTypesRequest = {
    type: typeof ActionTypes.CREDIT_TYPES_FETCH_REQUEST;
    payload: never;
}

type FetchCreditTypesFailure = {
    type: typeof ActionTypes.CREDIT_TYPES_FETCH_FAILURE;
    payload: Error;
}

type FetchCreditTypesSuccess = {
    type: typeof ActionTypes.CREDIT_TYPES_FETCH_SUCCESS;
    payload: CreditType[];
}

/**
 * Fetch credit types
 */
function fetchCreditTypes() {
    return createAction<RootState, CreditType[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/credit-types`,
        method: 'GET',
        types: [
            ActionTypes.CREDIT_TYPES_FETCH_REQUEST,
            ActionTypes.CREDIT_TYPES_FETCH_SUCCESS,
            ActionTypes.CREDIT_TYPES_FETCH_FAILURE,
        ],
    })
}

export type FetchCreditTypesAction = FetchCreditTypesRequest
    | FetchCreditTypesFailure
    | FetchCreditTypesSuccess

export default fetchCreditTypes
